import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../../types/types';
import {
    boardSetKNBCardColorTagsSearchUsed
} from '../../../../../../../../rest/effects/board/boardSetKNBCardColorTagsSearchUsed';
import { getActiveBoardId } from '../../../../../../../../store/model/selectors/getActiveBoardId';

export const onSearchClick = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(boardSetKNBCardColorTagsSearchUsed(getActiveBoardId(getState()), true));
    };

    return action;
};
